import React, { useState } from "react";
import { Button, Col, FloatingLabel, Form, Row } from "react-bootstrap";
import Validator from "../../services/Validator";

/**
 * SepaComponent
 * 
 * form so that customer can fill his account informations.
 * 
 * @param {sepa} props - setter for sepa object in InquaryPage
 * @param {step} props - setter for step object in InquaryPage
 * 
 * @returns next step
 */
const SepaComponent = ({setStep, data, setData, errors, setErrors}) => {

    const VALIDATOR = new Validator();
    const [validated, setValidated] = useState(false);


    /**
     * Handlers
     */
    const ibanHandler = (event) => {
        const inputValue = event.target.value;
    
        // replace any characters that aren't digit or letter
        const formattedValue = inputValue.replace(/[^a-zA-Z0-9]/g, '');
    
        // group characters in 4 block
        const restFormatted = formattedValue.substring(0).replace(/(.{4})(?!$)/g, '$1 ');
    
        // set new value with uppercase
        setData(prev => ({...prev,
            partner: ({...prev.partner, x_account_iban: restFormatted.toUpperCase()})
        }));
    };

    // Button "weiter" click. show next screen and set card data to inquary page
    const handleSubmit = (e) => {
        e.preventDefault();
        const allErrors = {};

        if (!VALIDATOR.StringLength(3, 80, data.partner.x_account_owner)) allErrors.x_account_owner = "Kontoinhaber ist erforderlich";
        if (!VALIDATOR.ibanValid(data.partner.x_account_iban.replace(/\s+/g, ''))) allErrors.x_account_iban = "Eingegebene IBAN ist falsch";

        if (Object.keys(allErrors).length > 0) {
            return setErrors(allErrors);
        }

        setStep(5);
    }
    
    // Views
    return (
        <Form validated={validated} onSubmit={e => handleSubmit(e)}>
            <Row className="mb-5">
                <h5 className="text-energo">Kontodaten</h5>
            </Row>
            <Row className="mb-3">
                <Col xs="12" md="5" xl="6">
                    <Form.Group>
                        <FloatingLabel label="Kontoinhaber">
                            <Form.Control
                                type="text"
                                placeholder="Kontoinhaber"
                                value={data.partner.x_account_owner}
                                onChange={e => {setErrors({}); setData(prev => ({...prev,
                                    partner: ({...prev.partner, x_account_owner: e.target.value})
                                }))}}
                               isValid={VALIDATOR.StringLength(3, 80, data.partner.x_account_owner)}
                               isInvalid={errors.x_account_owner}
                            />
                        </FloatingLabel>
                        {errors.x_account_owner? <small className="text-danger">{errors.x_account_owner}</small>:null}
                    </Form.Group>
                </Col>
                <Col xs="12" md="7" xl="6">
                    <Form.Group>
                        <FloatingLabel label="IBAN">
                            <Form.Control
                                type="text"
                                placeholder="AT000000000000000000"
                                value={data.partner.x_account_iban}
                                onChange={e => {ibanHandler(e); setErrors({})}}
                                isValid={VALIDATOR.ibanValid(data.partner.x_account_iban.replace(/\s+/g, ''))}
                                isInvalid={errors.x_account_iban}
                                
                            />
                        </FloatingLabel>
                        {errors.x_account_iban? <small className="text-danger">{errors.x_account_iban}</small>:null}
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs="12" md="8" xl="6">
                    <Form.Group>
                        <FloatingLabel label="BIC">
                            <Form.Control 
                                type="text"
                                placeholder="BIC"
                                value={data.partner.x_account_bic}
                                onChange={e => {setErrors({}); setData(prev => ({...prev,
                                    partner: ({...prev.partner, x_account_bic: e.target.value})
                                }))}}
                                isValid={data.partner.x_account_bic !== ""}
                            />
                        </FloatingLabel>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mt-5 mb-1">
                <Col className="text-end">
                    <Button variant="warning" onClick={() => setStep(3)} style={{marginRight: 5}}>Zurück</Button>
                    <Button type="submit" className="btn-energo">Weiter</Button>
                </Col>
            </Row>
        </Form>
    )
}

export default SepaComponent;